export const wordpuzzlehint = {
  apple: "A popular fruit with a crunchy texture.",
  banana: "A yellow fruit that is often curved.",
  cherry: "A small, round, red fruit that grows on trees.",
  grape: "A small, sweet fruit that can be green or purple.",
  orange: "A citrus fruit with a bright orange color.",
  dog: "A common pet known for its loyalty.",
  cat: "A furry animal often kept as a pet.",
  house: "A place where people live.",
  car: "A mode of transportation with four wheels.",
  sun: "The bright, shining star in our solar system.",
  moon: "Earth's natural satellite.",
  tree: "A tall, woody plant with branches and leaves.",
  bird: "Feathered creatures that can fly.",
  book: "A collection of written or printed pages.",
  chair: "A piece of furniture for sitting.",
  table: "A flat surface for placing objects.",
  flower: "A colorful bloom from a plant.",
  ocean: "A vast body of saltwater.",
  smile: "A facial expression that shows happiness.",
  laugh: "The sound made when someone finds something funny.",
  run: "To move quickly on foot.",
  jump: "Springing into the air with both feet.",
  fish: "Water-dwelling animals with scales.",
  cake: "A sweet baked dessert.",
  hat: "A head-covering accessory.",
  shirt: "A garment worn on the upper body.",
  pants: "Clothing for the lower part of the body.",
  music: "Sounds arranged in a harmonious way.",
  rain: "Water falling from the sky.",
  snow: "Frozen precipitation in the form of white flakes.",
  star: "A distant celestial object in the night sky.",
  pen: "A writing instrument.",
  pencil: "A writing tool with a graphite core.",
  ball: "A round object used in various sports.",
  game: "An activity for fun and entertainment.",
  watch: "A timekeeping device worn on the wrist.",
  clock: "A device used to tell time.",
  ship: "A vessel that travels on water.",
  beach: "Sandy shore by the sea.",
  key: "A small metal tool for unlocking things.",
  door: "An entryway into a building.",
  window: "An opening in a wall with glass.",
  cake: "A sweet baked dessert.",
  juice: "A drink made from pressed fruits.",
  train: "A long vehicle that runs on tracks.",
};

export const words = [
  "apple",
  "banana",
  "cherry",
  "grape",
  "orange",
  "dog",
  "cat",
  "house",
  "car",
  "sun",
  "moon",
  "tree",
  "bird",
  "book",
  "chair",
  "table",
  "flower",
  "ocean",
  "smile",
  "laugh",
  "run",
  "jump",
  "fish",
  "cake",
  "hat",
  "shirt",
  "pants",
  "music",
  "rain",
  "snow",
  "star",
  "pen",
  "pencil",
  "ball",
  "game",
  "watch",
  "clock",
  "ship",
  "beach",
  "moon",
  "key",
  "door",
  "window",
  "cake",
  "juice",
  "train",
  "apple",
  "bike",
  "ring",
  "rope",
];

export const wordLists = [
  ["Apple", "Banana", "Cherry", "Grape", "Orange"],
  ["Strawberry", "Lemon", "Peach", "Watermelon", "Pineapple"],
  ["Mango", "Kiwi", "Pear", "Blueberry", "Raspberry"],
  ["Dog", "Cat", "Elephant", "Lion", "Horse"],
  ["Tiger", "Monkey", "Giraffe", "Kangaroo", "Zebra"],
  ["Red", "Green", "Blue", "Yellow", "Purple"],
  ["Orange", "Pink", "Brown", "Black", "White"],
  ["Car", "Bicycle", "Bus", "Train", "Boat"],
  ["Helicopter", "Motorcycle", "Scooter", "Truck", "Aeroplane"],
  ["One", "Four", "Three", "Five", "Two"],
  ["Six", "Seven", "Eight", "Nine", "Ten"],
  ["Circle", "Square", "Triangle", "Rectangle", "Oval"],
  ["Diamond", "Heart", "Star", "Crescent", "Hexagon"],
  ["Pizza", "Burger", "Pasta", "Salad", "Sushi"],
  ["Pancake", "Ice Cream", "Sandwich", "Cake", "Spaghetti"],
];
